import type {z} from "zod";

import {createValidationIssue, requiredFieldValidation} from "@project/i18n";
import {z as zod} from "zod";

export function requiredStringSchema(schema: z.ZodType<string, string>, fieldLabelId: string) {
  return zod.string().superRefine((value, ctx) => {
    if (!value.trim()) {
      ctx.addIssue(createValidationIssue(requiredFieldValidation(fieldLabelId)));

      return;
    }

    const result = schema.safeParse(value);

    if (!result.success) {
      for (const issue of result.error.issues) ctx.addIssue({...issue});
    }
  });
}
